(() => {
  if (window.magicStudioLaunchInstalled) return;
  window.magicStudioLaunchInstalled = true;
  const setups = () => [...document.querySelectorAll('[data-studio-launch]')];
  function targetUrl(root) {
    const url = new URL(root.dataset.url, location.origin);
    url.searchParams.set('width', root.dataset.width);
    const form = document.getElementById(root.dataset.form);
    const id = form?.querySelector('[name="id"]')?.value;
    const variants = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
    const variant = variants.find(v => String(v.id) === id) || variants[0];
    const ft = variant?.title.match(/(\d+(?:\.\d+)?)\s*(?:ft|feet|foot|')/i);
    const inches = ft ? +ft[1]*12 : 24;
    if (Number.isInteger(inches/12) && inches >= 12 && inches <= 240) url.searchParams.set('length', inches);
    return url.href;
  }
  function refresh() {
    for (const root of setups()) {
      const old = document.querySelector(`.mmc-customizer[data-product-id="${root.dataset.product}"][data-layout="gang_sheet"] [data-open-editor]`);
      const link = root.querySelector('[data-studio-link]');
      link.hidden = !!old;
      if (old) {old.title = 'Open Gang Sheet Studio';}
      link.href = targetUrl(root);
    }
  }
  document.addEventListener('click', e => {
    const target = e.target instanceof Element ? e.target : null;
    const launcher = target?.closest('.mmc-customizer[data-layout="gang_sheet"] [data-open-editor], [data-studio-link]');
    if (!launcher) return;
    const product = launcher.closest('.mmc-customizer')?.dataset.productId;
    const root = launcher.closest('[data-studio-launch]') || setups().find(r => r.dataset.product === product);
    if (!root) return;
    e.preventDefault(); e.stopImmediatePropagation();
    location.assign(targetUrl(root));
  }, true);
  document.addEventListener('change', refresh);
  new MutationObserver(refresh).observe(document.body, {childList:true,subtree:true});
  refresh();
})();
